
// To run in Server

import React from 'react';
import { useNavigate } from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import logo from '../Assets/logo.png';  
import './NavigationBar.css';  
import { User, LayoutDashboard, Home, LogOut } from "lucide-react"; // Import icons

function NavigationBar() {
  const navigate = useNavigate();
  
  // Check if the user is logged in and get their first name
  const user = JSON.parse(localStorage.getItem("user")); 
  const isLoggedIn = user && user.user_name; // Check if user data exists
  const userName = isLoggedIn ? user.user_name.split(' ')[0] : ''; // Extract first name

  // Function to handle logout
  const handleLogout = () => {
    localStorage.clear(); // Clear user data
    navigate('/home'); // Redirect to home page
  };

  return (
    <Navbar expand="lg" className="navbar-custom">
      <Container fluid>
        {/* Logo on the left */}
        <Navbar.Brand href="#" className="navbar-logo">
          <img src={logo} alt="Logo" />
        </Navbar.Brand>

        {/* Title in the center */}
        <Navbar.Brand href="#" className="title">
          Award Management System
        </Navbar.Brand>

        {/* Navbar Toggle */}
        <Navbar.Toggle aria-controls="navbarScroll" className="navbar-toggle" />

        {/* Navbar Links */}
        <Navbar.Collapse id="navbarScroll">
          <Nav className="ml-auto">
            {/* Always show Home */}
           
            {/* Show other links only if user is logged in */}
            {isLoggedIn && (
              <>
               <Nav.Link href="/AMS/home">
                 <Home size={20} /> {/* Home Icon */}
               </Nav.Link>

                <Nav.Link href="/AMS/dashboard">
                  <LayoutDashboard size={20} /> {/* Dashboard Icon */}
                </Nav.Link>
                
                <Nav.Link href="/AMS/profile">
                  <User size={20} /> {/* Profile Icon */}
                  <span className="username">{userName}</span> {/* Display the user's first name */}
                </Nav.Link>
                
                <Nav.Link onClick={handleLogout} style={{ cursor: 'pointer' }}>
                  <LogOut size={20} /> {/* Logout Icon */}
                </Nav.Link>
              </>
            )}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default NavigationBar;


// to Run in Localhost


// import React from 'react';
// import { useNavigate } from 'react-router-dom';
// import Container from 'react-bootstrap/Container';
// import Nav from 'react-bootstrap/Nav';
// import Navbar from 'react-bootstrap/Navbar';
// import logo from '../Assets/logo.png';  
// import './NavigationBar.css';  
// import { User, LayoutDashboard, Home, LogOut } from "lucide-react"; // Import icons

// function NavigationBar() {
//   const navigate = useNavigate();
  
//   // Check if the user is logged in and get their first name
//   const user = JSON.parse(localStorage.getItem("user")); 
//   const isLoggedIn = user && user.user_name; // Check if user data exists
//   const userName = isLoggedIn ? user.user_name.split(' ')[0] : ''; // Extract first name

//   // Function to handle logout
//   const handleLogout = () => {
//     localStorage.clear(); // Clear user data
//     navigate('/home'); // Redirect to home page
//   };

//   return (
//     <Navbar expand="lg" className="navbar-custom">
//       <Container fluid>
//         {/* Logo on the left */}
//         <Navbar.Brand href="#" className="navbar-logo">
//           <img src={logo} alt="Logo" />
//         </Navbar.Brand>

//         {/* Title in the center */}
//         <Navbar.Brand href="#" className="title">
//           Award Management System
//         </Navbar.Brand>

//         {/* Navbar Toggle */}
//         <Navbar.Toggle aria-controls="navbarScroll" className="navbar-toggle" />

//         {/* Navbar Links */}
//         <Navbar.Collapse id="navbarScroll">
//           <Nav className="ml-auto">
//             {/* Always show Home */}
           
//             {/* Show other links only if user is logged in */}
//             {isLoggedIn && (
//               <>
//                <Nav.Link href="/home">
//                  <Home size={20} /> {/* Home Icon */}
//                </Nav.Link>

//                 <Nav.Link href="/dashboard">
//                   <LayoutDashboard size={20} /> {/* Dashboard Icon */}
//                 </Nav.Link>
                
//                 <Nav.Link href="/profile">
//                   <User size={20} /> {/* Profile Icon */}
//                   <span className="username">{userName}</span> {/* Display the user's first name */}
//                 </Nav.Link>
                
//                 <Nav.Link onClick={handleLogout} style={{ cursor: 'pointer' }}>
//                   <LogOut size={20} /> {/* Logout Icon */}
//                 </Nav.Link>
//               </>
//             )}
//           </Nav>
//         </Navbar.Collapse>
//       </Container>
//     </Navbar>
//   );
// }

// export default NavigationBar;
